// extracted by mini-css-extract-plugin
export default {"list":"information-list_list__QDxdw","render":"information-list_render__KPnnO"};